import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";

const AddMQTTSetting = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const { getUrlByOperation } = useApiUrls();

  const [formData, setFormData] = useState({
    settingname: "",
    settingtype: "",
    remark: "",
    active: true,
    json: "{}"
  });

  // Handle text/select input
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle JSON field
  const handleJsonChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, json: value }));
  };

  const isJsonValid = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  };

  // Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      setMessage("Failed: Missing authentication token.");
      return;
    }

    try {
      const payload = {
        ...formData,
        active: formData.active === "true" || formData.active === true,
      };

      const response = await axios.post(
        "https://api.dqr-display-tms.bonrix.in/api/JsonSettingOperation/SubUser/Insert",
        payload,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      // API SUCCESS
      if (response.data?.isresponse && response.data?.responsestatus === "SUCCESS") {
        setMessage("MQTT Setting added successfully!");

        // Reset form
        setFormData({
          settingname: "",
          settingtype: "",
          remark: "",
          active: true,
          json: "{}",
        });

        setTimeout(() => navigate("/mqttSetting"), 2500);
        return;
      }

      // API FAIL (Shows already exist also)
      setMessage(response.data?.errormsg || "Failed to add Json Setting.");

    } catch (error) {
      setMessage(
        error.response?.data?.errormsg ||
        error.message ||
        "Server error while adding Json Setting."
      );
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <h1>Add Json Setting</h1>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="card card-info">
                <div className="card-header">
                  <h3 className="card-title">Add Json Setting</h3>
                </div>

                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-6">
                        <label>Setting Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="settingname"
                          required
                          value={formData.settingname}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-sm-6">
                        <label>Setting Type</label>
                        <select
                          className="form-control"
                          name="settingtype"
                          required
                          value={formData.settingtype}
                          onChange={handleChange}
                        >
                          <option value="">Select setting type...</option>
                          <option value="MQTT setting">MQTT setting</option>
                          <option value="Screen setting">Screen setting</option>
                          <option value="Wifi setting">Wifi setting</option>
                          <option value="Master setting">Master setting</option>
                        </select>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <label>Description</label>
                        <input
                          type="text"
                          className="form-control"
                          name="remark"
                          value={formData.remark}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-sm-6">
                        <label>Active</label>
                        <select
                          name="active"
                          className="form-control"
                          value={formData.active}
                          onChange={handleChange}
                        >
                          <option value={true}>Active</option>
                          <option value={false}>Inactive</option>
                        </select>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm-12">
                        <label>JSON Configuration</label>
                        <textarea
                          className={`form-control ${
                            !isJsonValid(formData.json) ? "is-invalid" : ""
                          }`}
                          rows="4"
                          name="json"
                          value={formData.json}
                          onChange={handleJsonChange}
                        ></textarea>

                        {!isJsonValid(formData.json) && (
                          <div className="invalid-feedback">
                            Invalid JSON format
                          </div>
                        )}
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-info mt-3"
                      disabled={!isJsonValid(formData.json)}
                    >
                      Add
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* SUCCESS / FAILED MESSAGES */}
      {message === "MQTT Setting added successfully!" && (
        <SuccessMessage message={message} />
      )}

      {message && message !== "MQTT Setting added successfully!" && (
        <FailedMessage message={message} />
      )}
    </>
  );
};

export default AddMQTTSetting;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
